// Core imports
import * as React from 'react';

// Components imports
import SelectOption from './components/SelectOption';

// Models imports Style and misc imports
import './Select.scss';

export default class Select extends React.Component<
  ISelectProps,
  ISelectState
> {
  private selectRef: any = null;

  constructor(props: ISelectProps) {
    super(props);

    this.state = {
      optionsAreShown: false
    };
  }

  /* buildContainerStyles: Classes and styling of container are applied using what user sends in props

	 */
  private buildContainerStyles = (): {
    classes: string;
    styles: any;
  } => {
    const { renderClass, width, height } = this.props;
    const styles: any = {};
    if (renderClass) {
      styles.width = '100%';
      return { classes: '', styles };
    }
    styles.width = width ? width : 'auto';
    styles.height = height ? height : 'auto';

    return { classes: '', styles };
  };

  /* buildHeaderStyles : Classes and styling are applied using what user sends in props
   */

  private buildHeaderStyles = (): {
    classes: string;
    styles: any;
  } => {
    return { classes: '', styles: {} };
  };

  /* buildOptionsStyles: Classes and styling are applied to options fly out menu

   */
  private buildOptionsStyles = (): {
    classes: string;
    styles: any;
  } => {
    const styles: any = {};
    let classes: string = '';
    const { activeOption, optionsShown } = this.props;
    const { optionsAreShown } = this.state;
    const totalOptions =
      activeOption === null ? optionsShown : optionsShown - 1;

    styles.width = optionsAreShown ? '100%' : '0px';
    styles.height = optionsShown ? `${totalOptions * 30}px` : 'auto';
    classes = optionsAreShown ? 'opened' : 'closed';
    return { classes, styles };
  };

  /* openOptions: Opens the options menu

		 */
  private openOptions = (): void => {
    this.setState({ optionsAreShown: true });
  };

  /* closeOption: Closes the options menu

		 */
  private closeOptions = (): void => {
    this.setState({ optionsAreShown: false });
  };

  /* handleMenuState: Handles the options menu status and side effects

		 */
  private handleMenuState = () => {
    if (!this.props.isLoading) {
      if (this.state.optionsAreShown) {
        this.closeOptions();
      } else {
        this.openOptions();
      }
    }
  };

  /*
			renderOptions
		 */
  private renderOptions = () => {
    const options: any = [];
    this.props.options.map((option, index) => {
      if (
        this.props.activeOption === null ||
        option.value !== this.props.activeOption.value
      ) {
        options.push(
          <SelectOption
            key={index}
            value={option.value}
            label={option.label}
            onSelected={() => {
              this.props.onSelected(option);
              this.closeOptions();
            }}
          />
        );
      }
    });

    return options;
  };

  /* 
    getHeader
   */
  private getHeader = (selecticon: string) => {
    if (this.props.isLoading) {
      return <p>Loading...</p>;
    } else if (this.props.placeholder && this.props.activeOption === null) {
      return (
        <React.Fragment>
          <p
            className={`select--placeholder ${this.props.placeholderTransform}`}
          >
            {this.props.placeholder}
          </p>
          <i className={selecticon} />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <p
            className={`select--placeholder ${this.props.placeholderTransform}`}
          >
            {this.props.activeOption.label}
          </p>
          <i className={selecticon} />
        </React.Fragment>
      );
    }
  };

  private handleClickOutside = (e: any) => {
    if (this.selectRef == null || this.selectRef.contains == null) {
      return;
    }
    if (this.selectRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      optionsAreShown: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  public render() {
    const containerStyles = this.buildContainerStyles();
    // const headerStyles = this.buildHeaderStyles();
    const optionsStyles = this.buildOptionsStyles();
    const selecticon = this.state.optionsAreShown
      ? 'rpds-expand-less'
      : 'rpds-expand-more';
    const { renderClass } = this.props;
    return (
      <div
        className="rp-select"
        style={containerStyles.styles}
        ref={ref => (this.selectRef = ref)}
      >
        <div
          className={`rp-select--header ${renderClass ? renderClass : ''}`}
          onClick={this.handleMenuState}
        >
          {this.getHeader(selecticon)}
        </div>
        <div
          className={`rp-select--options ${optionsStyles.classes} ${
            renderClass ? renderClass : ''
          }`}
          style={optionsStyles.styles}
        >
          {this.renderOptions()}
        </div>
      </div>
    );
  }
}

interface ISelectProps {
  onSelected(itemValue: any): any;
  height?: string;
  width?: string;
  options: Array<ISelectOption | any>;
  activeOption: ISelectOption | null;
  isLoading: boolean;
  optionsShown?: number;
  placeholder?: string;
  placeholderTransform?: 'uppercase' | 'lowercase' | 'capitalize';
  renderClass?: string;
}

interface ISelectState {
  optionsAreShown: boolean;
}

interface ISelectOption {
  value: any;
  label: string;
}
